import React, { useEffect, useState } from "react";

import LayoutWrapper from "../../../../common/LayoutWrapper";
import EmergencyFolder from "../../../../components/cases/documents/guardianship/EmergencyFolder";
import Signature from "../../../../components/cases/documents/guardianship/Signature";
import GetStarted from "../../../../components/cases/documents/guardianship/GetStarted";
import Guardian from "../../../../components/cases/documents/guardianship/Guardian";
import Wishes from "../../../../components/cases/documents/guardianship/Wishes";
import Overview from "../../../../components/cases/documents/guardianship/Overveiw";
import DocSwiper from "../../../../common/Swipers/DocsSwiper";
import AdviserDocsWrapper from "../../../../common/AdviserDocsWrapper";

import { useSelector, useDispatch } from "react-redux";
import { customTab, nextTab, preTab } from "../../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../../redux/slices/features/assetsOnBoardingSlice";
import { connect } from "react-redux";
import { resetCard } from "../../../../redux/slices/CardSlices";
import { guardianshipSteps } from "../../../../constants/constants";
import { getGuardianOridinance } from "../../../../services/documentServices";
import {
  getUserIdFromLocalStorage,
  overAllStatus,
} from "../../../../utils/Utilities";

import "../../../../components/yourAssets/BOA/BOA.scss";
import { useLocation } from "react-router-dom";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import { useTranslation } from "react-i18next";

const GuardianshipPage = ({
  currentTab,
  nextTab,
  preTab,
  customTab,
  resetCard,
}) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [steps, setSteps] = useState(guardianshipSteps);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const handleResetCard = () => {
    resetCard();
  };
  const handleNext = () => {
    handleResetCard();
    nextTab();
  };
  const handleBack = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };

  const tabMaping = {
    1: (
      <GetStarted
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <Guardian
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
        buttonDisabled={buttonDisabled}
      />
    ),
    3: (
      <Wishes
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    4: (
      <EmergencyFolder
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
        buttonDisabled={buttonDisabled}
      />
    ),
    5: (
      <Signature
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    6: (
      <Overview
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );

  async function fetchData() {
    const arr = [];
    const result = await getGuardianOridinance(uID);
    if (result?.success && result?.payLoad) {
      const {
        guardianDetermineDetail,
        primaryGuardian,
        secondaryGuardian,
        guardianByNoMean,
        guardianEmergencyStepStatus,
      } = result?.payLoad;

      const array = [
        guardianDetermineDetail?.stepStatus,
        primaryGuardian?.stepStatus === 2 && secondaryGuardian?.stepStatus === 2
          ? 2
          : 1,
        guardianByNoMean?.stepStatus,
        guardianEmergencyStepStatus || 0,
        2,
        2,
      ];

      steps.forEach((elem, index) => {
        if (index !== steps.length - 1) {
          arr.push({ ...elem, stepStatus: array[index] });
        }
        if (index === steps.length - 1) {
          const res = overAllStatus(array);
          arr.push({ ...elem, stepStatus: res ? 2 : 1 });
        }
      });

      setSteps(arr);
    }
  }
  useEffect(() => {
    fetchData();
  }, [currentTab]);

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const renderTab = () => {
    return tabMaping[currentTab];
  };
  return (
    <>
      <AdviserDocsWrapper>
        <LayoutWrapper
          minHeight="calc(100vh - 120px) !important"
          borderShadow={true}
        >
          <DocSwiper
            tab={currentTab}
            back={handleBack}
            custom={handleCustomTab}
            list={steps}
          />

          {renderTab()}
          {currentTab !== 2 && currentTab !== 4 && (
            <>
              {currentTab < 5 ? (
                <div
                  style={{
                    minWidth: "310px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <SecondaryButton
                    title={t("save-and-continue")}
                    bgColor="#E8D7E5"
                    borderRadius="14px"
                    width="180px"
                    marginLeft="20px"
                    border="none"
                    hoverBgColor="color.magentaLight1"
                    textTransform="initial"
                    padding="0rem"
                    height="2.7rem"
                    form="form_submit"
                    type="submit"
                    disabled={buttonDisabled}
                  />

                  <LinkButton
                    title={t("skip-for-now")}
                    bgColor="color.transparent"
                    borderRadius="14px"
                    fontSize="0.8rem"
                    width="110px"
                    marginLeft="0px"
                    border="none"
                    click={handleNext}
                    textTransform="initial"
                  />
                </div>
              ) : (
                <div
                  className="button-container-2"
                  style={{
                    minWidth: "310px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <PrimaryButton
                    title={t("save")}
                    bgColor="#E8D7E5"
                    color="#444561"
                    padding="10px 60px"
                    textTransform="initial"
                    borderRadius={"18px"}
                    boxShadow={0}
                    form="form_submit"
                  />
                </div>
              )}
            </>
          )}
        </LayoutWrapper>
      </AdviserDocsWrapper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GuardianshipPage);
